import React, { useState } from "react";
import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { CheckBadgeIcon, CheckCircleIcon, NoSymbolIcon } from "@heroicons/react/24/solid";
import { formatTimestampDifference } from "@Utils/common";


interface ContactsTableInterface {
  data: any,
  openEditContactModal: (contact_index: number) => void
  openDeleteContactModal: (contactmap_id: number) => void
}


const ContactTable = (props: ContactsTableInterface) => {
  return (
    <div className="w-full">
      <div className="bg-white rounded-lg border border-gray-100">
        {/* Desktop Table */}
        <table className="w-full hidden md:table">
          <thead>
            <tr className="border-b border-gray-100 ">
              <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Photo</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Name</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Instagram Username</th>
              {/* <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Business Follow User</th> */}
              <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Follow Status</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Created Date</th>
              {/* <th className="px-4 py-3 text-right text-sm font-medium text-gray-600">Actions</th> */}
            </tr>
          </thead>
          <tbody>
            {props?.data && props?.data.length > 0 ? (
              props.data.map((contact: any, index: number) => (
                <tr key={`desktop-${contact.id}`} className="border-b border-gray-50 hover:bg-gray-50 transition-colors">
                  <td className="px-4 py-3">
                  <img className="h-10 w-10 rounded-full" src={contact?.profile_pic} alt="Profile" />
                  </td>
                  <td className="px-4 py-3">
                    <p className="text-[15px] text-gray-900">{contact.name}</p>
                  </td>
                  <td className="px-4 py-3">
                    <p className="text-[15px] text-gray-900">{contact.username}</p>
                  </td>
                  {/* <td className="px-4 py-3">
                    {contact.is_business_follow_user ? 
                      <CheckCircleIcon className="h-5 w-5 text-green-600" /> : 
                      <NoSymbolIcon className="h-5 w-5 text-gray-400" />}
                  </td> */}
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">
                      <div className="flex items-center gap-1">
                        <span className="text-[13px] text-gray-600">You follow:</span>
                        {contact.is_business_follow_user ? 
                          <CheckCircleIcon className="h-5 w-5 text-green-600" /> : 
                          <NoSymbolIcon className="h-5 w-5 text-gray-400" />}
                      </div>
                      <div className="flex items-center gap-1">
                        <span className="text-[13px] text-gray-600">Follows you:</span>
                        {contact.is_user_follow_business ? 
                          <CheckCircleIcon className="h-5 w-5 text-green-600" /> : 
                          <NoSymbolIcon className="h-5 w-5 text-gray-400" />}
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3">
                    <p className="text-[13px] text-gray-600">{formatTimestampDifference(contact.created_at)}</p>
                  </td>
                  {/* <td className="px-4 py-3 text-right">
                    <div className="flex justify-end gap-2">
                      <button
                        onClick={() => props.openEditContactModal(index)}
                        className="p-2 text-gray-500 hover:text-gray-700 rounded-lg transition-colors"
                      >
                        <Pencil1Icon className="w-[18px] h-[18px]" />
                      </button>
                      <button
                        onClick={() => props.openDeleteContactModal(contact.id)}
                        className="p-2 text-gray-500 hover:text-gray-700 rounded-lg transition-colors"
                      >
                        <TrashIcon className="w-[18px] h-[18px]" />
                      </button>
                    </div>
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="px-4 py-6 text-center">
                  <p className="text-gray-500 text-[15px]">No contacts found</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Mobile Table */}
        <table className="w-full md:hidden">
          <tbody>
            {props?.data && props?.data.length > 0 ? (
              props.data.map((contact: any, index: number) => (
                <tr key={`mobile-${contact.id}`} className="border-b border-gray-50">
                  <td className="px-4 py-3">
                    <div className="space-y-3">
                      <div className="flex items-center gap-3">
                        <img className="h-10 w-10 rounded-full" src={contact?.profile_pic} alt="Profile" />
                        <div>
                          <p className="text-[15px] font-medium text-gray-900">{contact.name}</p>
                          <p className="text-[13px] text-gray-500">@{contact.username}</p>
                          <p className="text-[13px] text-gray-500 mt-1">{formatTimestampDifference(contact.created_at)}</p>
                        </div>
                        <div className="flex gap-3">
                          <div className="flex items-center gap-1">
                            <span className="text-[13px] text-gray-600">You follow:</span>
                            {contact.is_business_follow_user ? 
                              <CheckCircleIcon className="h-5 w-5 text-green-600" /> : 
                              <NoSymbolIcon className="h-5 w-5 text-gray-400" />}
                          </div>
                          <div className="flex items-center gap-1">
                            <span className="text-[13px] text-gray-600">Follows you:</span>
                            {contact.is_user_follow_business ? 
                              <CheckCircleIcon className="h-5 w-5 text-green-600" /> : 
                              <NoSymbolIcon className="h-5 w-5 text-gray-400" />}
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center justify-between">
                        {/* <div className="flex gap-3">
                          <div className="flex items-center gap-1">
                            <span className="text-[13px] text-gray-600">You follow:</span>
                            {contact.is_business_follow_user ? 
                              <CheckCircleIcon className="h-5 w-5 text-green-600" /> : 
                              <NoSymbolIcon className="h-5 w-5 text-gray-400" />}
                          </div>
                          <div className="flex items-center gap-1">
                            <span className="text-[13px] text-gray-600">Follows you:</span>
                            {contact.is_user_follow_business ? 
                              <CheckCircleIcon className="h-5 w-5 text-green-600" /> : 
                              <NoSymbolIcon className="h-5 w-5 text-gray-400" />}
                          </div>
                        </div> */}
                        {/* <div className="flex gap-2">
                          <button
                            onClick={() => props.openEditContactModal(index)}
                            className="p-2 text-gray-500 hover:text-gray-700 rounded-lg transition-colors"
                          >
                            <Pencil1Icon className="w-[18px] h-[18px]" />
                          </button>
                          <button
                            onClick={() => props.openDeleteContactModal(contact.id)}
                            className="p-2 text-gray-500 hover:text-gray-700 rounded-lg transition-colors"
                          >
                            <TrashIcon className="w-[18px] h-[18px]" />
                          </button>
                        </div> */}
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="px-4 py-6 text-center">
                  <p className="text-gray-500 text-[15px]">No contacts found</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContactTable;
